import React from 'react'
import {Link} from 'react-router-dom'
import {PaymentAccount, Reservation} from '../../types/app-types'
import LabeledValue from '../common/LabeledValue'
import {
  findAutoPayAccount,
  formatPaymentAccountFull
} from '../../services/utils'
import {getNavigationPaths} from '../../services/navigation'
import LoaderInline from '../common/LoaderInline'

interface AccountPaymentCardProps {
  accountId: string
  reservation: Reservation
  paymentAccountsQuery: {
    data?: PaymentAccount[]
    isLoading: boolean
  }
  className?: string
}

const AccountPaymentCard = ({
  accountId,
  paymentAccountsQuery,
  className = ''
}: AccountPaymentCardProps) => {
  const paths = getNavigationPaths(accountId)
  const autoPayAccount = findAutoPayAccount(
    paymentAccountsQuery.data,
    accountId
  )
  return (
    <div className={className}>
      <div className="card-default h-full">
        <div className="card-body-default">
          <div className="flex-grow">
            <h1 className="card-header">Payment Accounts</h1>
            {paymentAccountsQuery.isLoading ? <LoaderInline /> : ''}

            {!paymentAccountsQuery.isLoading && autoPayAccount ? (
              <>
                <LabeledValue
                  value={formatPaymentAccountFull(autoPayAccount)}
                  label="Payment Method"
                />
                <div className="text-md">
                  <span>Auto Pay</span>
                  <span className="text-secondary ml-4">Enabled</span>
                </div>
              </>
            ) : (
              ''
            )}

            {!paymentAccountsQuery.isLoading && !autoPayAccount ? (
              <>
                <h2 className="text-lg mb-2">Have You Considered AutoPay?</h2>
                <p className="text-md">
                  AutoPay will pay your bills automatically and it's easy to
                  setup. In today's busy world, that's one less thing for you to
                  worry about. We got you covered. Enroll in AutoPay today!
                </p>
              </>
            ) : (
              ''
            )}
          </div>
          <div className="card-actions flex-none h-8">
            <Link
              to={paths.PaymentAccounts}
              className="link link-primary text-sm"
            >
              Manage Accounts
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountPaymentCard
